module.exports = __webpack_public_path__ + "static/media/partlycloudy.svg.78842ccf.png";